import AnagraficaRegionale from "../";

const routes = [
    { name: "AnagraficaRegionaleTestPage", path: "/anagraficaregionale/test", component: AnagraficaRegionale.AnagraficaRegionaleTestPage, meta: { title: "FlussAnagraficaRegionaleTestPagei" } },
];
export default routes;
